<template>
    <div  class="phone">
        <div class="phoneApp">
            <div class="phoneAppContent">
                <div class="myappList" :style="{background:info.background}">我的应用</div>
                <div class="appList" >
                    <div class="appListItem" v-for="(item, index) in appList" :key="index" @click="itemClick(item)">
                        <div>
                            <img :src="item.logoUrl" alt="" >
                        </div>
                        <div>
                            {{ item.appName }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { cookie } from '../libs/location'
/* eslint-disable */ 
export default {
    data(){
        return {
            appList: [],
            info: {
                titleName: '',
                background: ''
            }
            
        }
    },
    created(){
        this.initData()
        this.doInit()
        this.getData()
        this.info.titleName = this.$store.state.loginData.sysLogoTitle.sys_portal_title
        console.log(this.info.titleName)
        // alert(this.info.titleName)
    },
    methods:{
        initData() {
            this.$request.post('/sso/backgroundSet/findUsedBgSet').then(res => {
                console.log(res.data, 'res.data')
                const { code, data } = res.data
                const settingLogin = res.data.extra
                if (code === 'OK') {
                this.$store.commit('handleSettingData', data)
                this.$store.commit('loginSetting', settingLogin)
                return data
                }
            })
        },
        // 初始化
        doInit () {
            this.$request.post('/sso/app/getUserAppPageForMobile').then(res => {
                const { code, data } = res.data
                if (code === 'OK') {
                    if (data.length > 0) {
                        this.appList = data
                    }
                }
            })
        },
        // 获取标题
        getData(){
            this.$request.post('/sso/backgroundSet/findUsedBgSet').then(res => {
                this.info = {
                    titleName: res.data.extra.sysLogoTitle.sys_portal_title,
                    background: res.data.data.indexHeadColor
                }
            })
        },
        // 点击
        itemClick(item){
            if (item.appSign) {
                let _token = cookie.getCookie('token')
                this.$request.post('/sso/sync/loginOutInfo').then(res => {
                    let { code } = res.data
                    if (code === 'OK') {
                        window.location.href = `${this.$baseUrl}/sso/redirect/autoLogin?appSign=${item.appSign}&authorization=${_token}&fromType=mobile`, `sso${item.appSign}`
                    }
                })
            }
        }
    }
}
</script>
<style lang="less" scoped>
.phone{
    background-color: #eee;
    height: 100vh;
    .phoneHeader{
        width: 100%;
        height: 350px;
        line-height: 350px;
        font-size: 80px;
        font-weight: 600;
        text-align: center;
        color: #fff;
    }
    .phoneApp{
        width: 100%;
        height: 1950px;
        padding: 50px;
        .phoneAppContent{
            .myappList{
                height: 200px;
                padding-bottom: 80px;
                padding-left: 40px;
                color: #fff;
                background-color: #fff;
                line-height: 200px;
                font-size: 70px;
                border-top-left-radius: 50px;
                border-top-right-radius: 50px;
            }
            .appList{
                background: #fff;
                height: 1650px;
                padding-top: 50px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                border-bottom-left-radius: 50px;
                border-bottom-right-radius: 50px;
                .appListItem{
                    width: 24%;
                    height: 500px;
                    text-align: center;
                    div:last-child{
                        margin-top: 30px;
                    }
                    img{
                        width: 300px;
                        height: 300px;
                    }
                }
            }
            .appList::after{
                content: '';
                flex: auto; 
            }
        }
        
        
    }
}
</style>